import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './global.css';
import { AuthenticationProvider } from './hooks/useAuthentication.tsx';
import { installAuthInterceptor } from './services/auth/axios-interceptor.ts';

// Installed before the first render so no request can race it. Renews the
// 15-minute access token and replays 401s for the direct axios calls that do
// not go through Apollo's retry link.
installAuthInterceptor();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AuthenticationProvider>
    <App />
  </AuthenticationProvider>,
);
